// removed by extract-text-webpack-plugin
module.exports = {"UrlLink":"UrlLink-module__UrlLink__DSTS2","Infotext":"UrlLink-module__Infotext__1vnpE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/UrlLink/UrlLink.module.css
// module id = 1712
// module chunks = 31